import { useContext, useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { UserContext } from "../../App";
import useInvoke from "../../Tools/Invoker";
import GetOiler from "../Tools/OilerGetOiler";
import toast from "react-hot-toast";
import CheckToken from "../../_Login/CheckToken";
import GetHeaders from "../Tools/OilerGetHeadersByConfig";
import ConfigurationSave from "../Tools/OilersConfigurationSave";
import HeaderSave from "../Tools/OilersHeaderSave";

const OilerConfigurationNew = () => {
    const [user, setUser] = useContext(UserContext);
    const navigate = useNavigate();
    const { id } = useParams(); //oiler ID
    CheckToken(user["id"], user["token"]).then((result) => { if (!result) { setUser({}); navigate("/Login"); } });

    const [oiler, setOiler] = useState({});
    const [configurations, setConfigurations] = useState([]);
    const [headers, setHeaders] = useState([]);
    const [oils, setOils] = useState([]);

    const [selectedConfig, setSelectedConfig] = useState({});

    const response92 = useInvoke("WebApps", "92", { "@oilerID": id });
    const response95 = useInvoke("WebApps", "95", {});

    useEffect(() => {

        if (response92.data.payload != undefined) {
            const myConfigurations = JSON.parse(response92.data.payload).data;

            let configList = [];

            myConfigurations.forEach((entry, index) => {
                let obj = {
                    ConfigID: entry[0],
                    OilID: entry[1],
                    OilName: entry[2],
                    CustomerBlankNum: entry[3],
                    Length: entry[4],
                    Width: entry[5],
                    Speed: entry[6],
                    Coverage: entry[7],
                    NumberOfBlanks: entry[8],
                    OilTemp: entry[9],
                    AsShipped: entry[10],
                    configString: `
                    #${entry[0]}: 
                    ${entry[8] > 1 ? `${entry[8]} Blanks` : `${entry[8]} Blank`},
                    #${entry[3]},
                    ${entry[2]}, 
                    ${entry[9]}°C,                   
                    ${entry[4]}cm x ${entry[5]}cm,
                    ${entry[6]} fpm,
                    ${entry[7]}mg/sft                                       
                    ${entry[10] == "True" ? ", As Shipped: ✓" : ", As Shipped: ✗"}
                    `
                }

                configList.push(obj);
            });

            setConfigurations(configList);
        }

        if (response95.data.payload != undefined) {

            const myOils = JSON.parse(response95.data.payload).data;

            let oilList = [];

            myOils.forEach((entry, index) => {

                oilList.push({
                    OilID: entry[0],
                    OilName: entry[1]
                });
            });

            setOils(oilList);
        }

    }, [response92.data.payload, response95.data.payload]);

    useEffect(() => {
        GetOiler(id)
            .then((result) => {
                if (result !== undefined) {
                    const myOiler = JSON.parse(result.payload).data;
                    let obj = {
                        OilerID: myOiler[0][0],
                        JobNum: myOiler[0][1],
                        SiteAddressID: myOiler[0][2],
                        NumTestPoints: myOiler[0][3],
                        InFeedSensorDistance: myOiler[0][4],
                        CustomerID: myOiler[0][5],
                        CustomerName: myOiler[0][6],
                        CustomerAddress: myOiler[0][7],
                        CityStateZip: myOiler[0][8],
                        SiteName: myOiler[0][9],
                        SiteAddressName: myOiler[0][10],
                        SiteCityStateZip: myOiler[0][11],
                        DateCreated: myOiler[0][12],
                        CreatedByID: myOiler[0][13],
                        CreatedByName: myOiler[0][14],
                    };
                    setOiler(obj);
                }
            });
    }, []);

    const handleImportConfiguration = () => {
        const configID = document.querySelector("select").value;
        if (configID == "") {
            toast.error("Please select a configuration to import.");
            return;
        }

        // Find configuration in configurations
        const config = configurations.find((config) => config.ConfigID == configID);

        setSelectedConfig(config);
        toast.success("Configuration imported successfully.");

        // Get headers
        GetHeaders(configID).then((result) => {
            if (result.success) {
                const myHeaders = JSON.parse(result.payload).data;
                let headerList = [];
                myHeaders.forEach((entry, index) => {
                    let obj = {
                        HeaderID: entry[0],
                        ConfigID: entry[1],
                        Location: entry[2],
                        FlowSP: entry[3],
                        OuterBarSprayVoltage: entry[4],
                        OuterBarRestingVoltage: entry[5],
                        OuterBarIdleVoltage: entry[6],
                        CenterBarSprayVoltage: entry[7],
                        CenterBarRestingVoltage: entry[8],
                        CenterBarIdleVoltage: entry[9],
                        NozzleSprayVoltage: entry[10],
                        NozzleRestingVoltage: entry[11],
                        NozzleIdleVoltage: entry[12],
                        BoostSprayVoltage: entry[13],
                        BoostRestingVoltage: entry[14],
                        BoostIdleVoltage: entry[15],
                        HighVoltageOnTime: entry[16],
                        HighVoltageOffTime: entry[17],
                        NozzleOnTime: entry[18],
                        NozzleOffTime: entry[19]
                    };
                    headerList.push(obj);
                });
                setHeaders(headerList);
            }
        });
    };

    useEffect(() => {

        //set fields to configuration and header values from import

        if (headers.length > 0) {

            //configuration
            document.getElementById("input_customerblanknum").value = selectedConfig.CustomerBlankNum;
            document.getElementById("input_length").value = selectedConfig.Length;
            document.getElementById("input_width").value = selectedConfig.Width;
            document.getElementById("input_speed").value = selectedConfig.Speed;
            document.getElementById("input_coverage").value = selectedConfig.Coverage;
            document.getElementById("input_numblanks").value = selectedConfig.NumberOfBlanks;
            document.getElementById("input_asshipped").value = selectedConfig.AsShipped;

            //oil
            document.getElementById("input_oilname").value = selectedConfig.OilID;
            document.getElementById("input_oiltemp").value = selectedConfig.OilTemp;

            //upper header
            document.getElementById("input_upperflowsp").value = headers[0].FlowSP;
            document.getElementById("input_upperouterspray").value = headers[0].OuterBarSprayVoltage;
            document.getElementById("input_upperouterrest").value = headers[0].OuterBarRestingVoltage;
            document.getElementById("input_upperouteridle").value = headers[0].OuterBarIdleVoltage;
            document.getElementById("input_uppercenterspray").value = headers[0].CenterBarSprayVoltage;
            document.getElementById("input_uppercenterrest").value = headers[0].CenterBarRestingVoltage;
            document.getElementById("input_uppercenteridle").value = headers[0].CenterBarIdleVoltage;
            document.getElementById("input_uppernozzlespray").value = headers[0].NozzleSprayVoltage;
            document.getElementById("input_uppernozzlerest").value = headers[0].NozzleRestingVoltage;
            document.getElementById("input_uppernozzleidle").value = headers[0].NozzleIdleVoltage;
            // document.getElementById("input_upperboostspray").value = headers[0].BoostSprayVoltage;
            // document.getElementById("input_upperboostrest").value = headers[0].BoostRestingVoltage;
            // document.getElementById("input_upperboostidle").value = headers[0].BoostIdleVoltage;
            document.getElementById("input_upperhighvoltageon").value = headers[0].HighVoltageOnTime;
            document.getElementById("input_upperhighvoltageoff").value = headers[0].HighVoltageOffTime;
            document.getElementById("input_uppernozzletimeon").value = headers[0].NozzleOnTime;
            document.getElementById("input_uppernozzletimeoff").value = headers[0].NozzleOffTime;

            //lower header
            document.getElementById("input_lowerflowsp").value = headers[1].FlowSP;
            // document.getElementById("input_lowerouterspray").value = headers[1].OuterBarSprayVoltage;
            // document.getElementById("input_lowerouterrest").value = headers[1].OuterBarRestingVoltage;
            // document.getElementById("input_lowerouteridle").value = headers[1].OuterBarIdleVoltage;
            // document.getElementById("input_lowercenterspray").value = headers[1].CenterBarSprayVoltage;
            // document.getElementById("input_lowercenterrest").value = headers[1].CenterBarRestingVoltage;
            // document.getElementById("input_lowercenteridle").value = headers[1].CenterBarIdleVoltage;
            document.getElementById("input_lowernozzlespray").value = headers[1].NozzleSprayVoltage;
            document.getElementById("input_lowernozzlerest").value = headers[1].NozzleRestingVoltage;
            document.getElementById("input_lowernozzleidle").value = headers[1].NozzleIdleVoltage;
            document.getElementById("input_lowerboostspray").value = headers[1].BoostSprayVoltage;
            document.getElementById("input_lowerboostrest").value = headers[1].BoostRestingVoltage;
            document.getElementById("input_lowerboostidle").value = headers[1].BoostIdleVoltage;
            document.getElementById("input_lowerhighvoltageon").value = headers[1].HighVoltageOnTime;
            document.getElementById("input_lowerhighvoltageoff").value = headers[1].HighVoltageOffTime;
            document.getElementById("input_lowernozzletimeon").value = headers[1].NozzleOnTime;
            document.getElementById("input_lowernozzletimeoff").value = headers[1].NozzleOffTime;

        }

    }, [headers, selectedConfig]);

    const handleClearAllFields = () => {

        //reset selected config
        setSelectedConfig({});
        setHeaders([]);
        document.getElementById("select_importconfig").value = "";

        document.getElementById("input_oilname").value = "";
        document.getElementById("input_customerblanknum").value = "";
        document.getElementById("input_length").value = "";
        document.getElementById("input_width").value = "";
        document.getElementById("input_speed").value = "";
        document.getElementById("input_coverage").value = "";
        document.getElementById("input_numblanks").value = "";
        document.getElementById("input_oiltemp").value = "";
        document.getElementById("input_asshipped").value = "";

        document.getElementById("input_upperflowsp").value = "";
        document.getElementById("input_upperouterspray").value = "";
        document.getElementById("input_upperouterrest").value = "";
        document.getElementById("input_upperouteridle").value = "";
        document.getElementById("input_uppercenterspray").value = "";
        document.getElementById("input_uppercenterrest").value = "";
        document.getElementById("input_uppercenteridle").value = "";
        document.getElementById("input_uppernozzlespray").value = "";
        document.getElementById("input_uppernozzlerest").value = "";
        document.getElementById("input_uppernozzleidle").value = "";
        // document.getElementById("input_upperboostspray").value = "";
        // document.getElementById("input_upperboostrest").value = "";
        // document.getElementById("input_upperboostidle").value = "";
        document.getElementById("input_upperhighvoltageon").value = "";
        document.getElementById("input_upperhighvoltageoff").value = "";
        document.getElementById("input_uppernozzletimeon").value = "";
        document.getElementById("input_uppernozzletimeoff").value = "";

        document.getElementById("input_lowerflowsp").value = "";
        // document.getElementById("input_lowerouterspray").value = "";
        // document.getElementById("input_lowerouterrest").value = "";
        // document.getElementById("input_lowerouteridle").value = "";
        // document.getElementById("input_lowercenterspray").value = "";
        // document.getElementById("input_lowercenterrest").value = "";
        // document.getElementById("input_lowercenteridle").value = "";
        document.getElementById("input_lowernozzlespray").value = "";
        document.getElementById("input_lowernozzlerest").value = "";
        document.getElementById("input_lowernozzleidle").value = "";
        document.getElementById("input_lowerboostspray").value = "";
        document.getElementById("input_lowerboostrest").value = "";
        document.getElementById("input_lowerboostidle").value = "";
        document.getElementById("input_lowerhighvoltageon").value = "";
        document.getElementById("input_lowerhighvoltageoff").value = "";
        document.getElementById("input_lowernozzletimeon").value = "";
        document.getElementById("input_lowernozzletimeoff").value = "";

        toast.success("All fields cleared.");

    };

    const validateField = (field, errorMessage, isNumber = false) => {
        if (field === "" || (isNumber && isNaN(field))) {
            toast.error(errorMessage + (isNumber ? " This field must be a number." : ""));
            return false;
        }
        return true;
    };

    const validateConfig = (config) => {
        const validations = [
            { field: config.length, message: "Please enter the length.", isNumber: true },
            { field: config.width, message: "Please enter the width.", isNumber: true },
            { field: config.numofblanks, message: "Please enter the number of blanks." },
            { field: config.coverage, message: "Please enter the coverage target." },
            { field: config.oiltemp, message: "Please enter the oil temperature.", isNumber: true },
            { field: config.asShipped, message: "Please select if the configuration is as shipped." },
            { field: config.oilID, message: "Please select an oil." },
            { field: config.customerblanknum, message: "Please enter the customer blank number." },
            { field: config.speed, message: "Please enter the speed." }
        ];

        return validations.every(({ field, message, isNumber }) => validateField(field, message, isNumber));
    };

    //validate header
    const validateHeader = (headerObj, fields) => {
        return fields.every(field =>
            validateField(headerObj[field], `Please enter the ${field.replace(/([A-Z])/g, ' $1').toLowerCase()}.`, true)
        );
    };

    //validate voltage fields
    const validateVoltage = (inputId, errorMessage) => {
        const value = document.getElementById(inputId).value;
        if (value > 60 || value < 0) {
            toast.error(errorMessage);
            return false;
        }
        return true;
    }

    const handleSave = () => {

        //if number blanks is not a number or is empty
        if (document.getElementById("input_numblanks").value == "" || isNaN(document.getElementById("input_numblanks").value)) {
            toast.error("Please select the number of blanks.");
            return;
        }

        //if oil is not selected
        if (document.getElementById("input_oilname").value == "") {
            toast.error("Please select an oil.");
            return;
        }

        //if as shipped is not selected
        if (document.getElementById("input_asshipped").value == "") {
            toast.error("Please select if the configuration is as shipped.");
            return;
        }
        const asShippedBool = document.getElementById("input_asshipped").value == "True" ? 1 : 0;

        //if speed is not a number or is empty
        if (document.getElementById("input_speed").value == "" || isNaN(document.getElementById("input_speed").value)) {
            toast.error("Please enter the speed. This field must be a number.");
            return;
        }

        //if coverage is not a number or is empty
        if (document.getElementById("input_coverage").value == "" || isNaN(document.getElementById("input_coverage").value)) {
            toast.error("Please enter the coverage target. This field must be a number.");
            return;
        }

        let configObj = {
            configid: "",
            oilerID: parseInt(id),
            oilID: parseInt(document.getElementById("input_oilname").value),
            customerblanknum: document.getElementById("input_customerblanknum").value,
            length: parseInt(document.getElementById("input_length").value),
            width: parseInt(document.getElementById("input_width").value),
            speed: parseInt(document.getElementById("input_speed").value),
            coverage: parseInt(document.getElementById("input_coverage").value),
            numofblanks: parseInt(document.getElementById("input_numblanks").value),
            oiltemp: parseInt(document.getElementById("input_oiltemp").value),
            asShipped: asShippedBool
        };

        let createHeaderObj = (location) => {

            //common fields
            let returnObj = {
                headerid: "",
                configid: "",
                location,
                flowsp: parseInt(document.getElementById(`input_${location.toLowerCase()}flowsp`).value),
                nozzlesprayvoltage: parseInt(document.getElementById(`input_${location.toLowerCase()}nozzlespray`).value),
                nozzlerestingvoltage: parseInt(document.getElementById(`input_${location.toLowerCase()}nozzlerest`).value),
                nozzleidlevoltage: parseInt(document.getElementById(`input_${location.toLowerCase()}nozzleidle`).value),
                highvoltageontime: parseInt(document.getElementById(`input_${location.toLowerCase()}highvoltageon`).value),
                highvoltageofftime: parseInt(document.getElementById(`input_${location.toLowerCase()}highvoltageoff`).value),
                nozzletimeon: parseInt(document.getElementById(`input_${location.toLowerCase()}nozzletimeon`).value),
                nozzletimeoff: parseInt(document.getElementById(`input_${location.toLowerCase()}nozzletimeoff`).value)

            }

            //if upper header
            if (location == "Upper") {
                returnObj.outerbarsprayvoltage = parseInt(document.getElementById(`input_${location.toLowerCase()}outerspray`).value);
                returnObj.outerbarrestingvoltage = parseInt(document.getElementById(`input_${location.toLowerCase()}outerrest`).value);
                returnObj.outerbaridlevoltage = parseInt(document.getElementById(`input_${location.toLowerCase()}outeridle`).value);
                returnObj.centerbarsprayvoltage = parseInt(document.getElementById(`input_${location.toLowerCase()}centerspray`).value);
                returnObj.centerbarrestingvoltage = parseInt(document.getElementById(`input_${location.toLowerCase()}centerrest`).value);
                returnObj.centerbaridlevoltage = parseInt(document.getElementById(`input_${location.toLowerCase()}centeridle`).value);
            }

            //if lower header
            else if (location == "Lower") {
                returnObj.boostsprayvoltage = parseInt(document.getElementById(`input_${location.toLowerCase()}boostspray`).value);
                returnObj.boostrestingvoltage = parseInt(document.getElementById(`input_${location.toLowerCase()}boostrest`).value);
                returnObj.boostidlevoltage = parseInt(document.getElementById(`input_${location.toLowerCase()}boostidle`).value);
            }

            return returnObj;

        };

        //validate voltages
        const inputs = [
            { id: "input_upperouterspray", error: "Outer Bar Spray Voltage must be between 0 and 60." },
            { id: "input_upperouterrest", error: "Outer Bar Resting Voltage must be between 0 and 60." },
            { id: "input_upperouteridle", error: "Outer Bar Idle Voltage must be between 0 and 60." },
            { id: "input_uppercenterspray", error: "Center Bar Spray Voltage must be between 0 and 60." },
            { id: "input_uppercenterrest", error: "Center Bar Resting Voltage must be between 0 and 60." },
            { id: "input_uppercenteridle", error: "Center Bar Idle Voltage must be between 0 and 60." },
            { id: "input_uppernozzlespray", error: "Nozzle Spray Voltage must be between 0 and 60." },
            { id: "input_uppernozzlerest", error: "Nozzle Resting Voltage must be between 0 and 60." },
            { id: "input_uppernozzleidle", error: "Nozzle Idle Voltage must be between 0 and 60." },
            { id: "input_lowernozzlespray", error: "Nozzle Spray Voltage must be between 0 and 60." },
            { id: "input_lowernozzlerest", error: "Nozzle Resting Voltage must be between 0 and 60." },
            { id: "input_lowernozzleidle", error: "Nozzle Idle Voltage must be between 0 and 60." },
            { id: "input_lowerboostspray", error: "Boost Spray Voltage must be between 0 and 60." },
            { id: "input_lowerboostrest", error: "Boost Resting Voltage must be between 0 and 60." },
            { id: "input_lowerboostidle", error: "Boost Idle Voltage must be between 0 and 60." }
        ];
        inputs.forEach(input => { if (!validateVoltage(input.id, input.error)) { return; } });

        //validate configuration
        if (!validateConfig(configObj)) {
            console.log(configObj);
            return;
        }

        //validate upper header
        let upperHeaderObj = createHeaderObj("Upper");
        if (!validateHeader(upperHeaderObj, ["outerbarsprayvoltage", "outerbarrestingvoltage", "outerbaridlevoltage", "centerbarsprayvoltage", "centerbarrestingvoltage", "centerbaridlevoltage", "nozzlesprayvoltage", "nozzlerestingvoltage", "nozzleidlevoltage", "highvoltageontime", "highvoltageofftime", "nozzletimeon", "nozzletimeoff", "flowsp"
        ])) {
            console.log("Submission failed. Upper header validation failed.");
            console.log(upperHeaderObj);
            return;
        }

        //validate lower header
        let lowerHeaderObj = createHeaderObj("Lower");
        if (!validateHeader(lowerHeaderObj, ["nozzlesprayvoltage", "nozzlerestingvoltage", "nozzleidlevoltage", "boostsprayvoltage", "boostrestingvoltage", "boostidlevoltage", "highvoltageontime", "highvoltageofftime", "nozzletimeon", "nozzletimeoff", "flowsp"
        ])) {
            console.log("Submission failed. Lower header validation failed.");
            console.log(lowerHeaderObj);
            return;
        }

        ConfigurationSave(configObj.configid, parseInt(configObj.oilerID), parseInt(configObj.oilID), configObj.customerblanknum, parseInt(configObj.length), parseInt(configObj.width), parseInt(configObj.speed), parseInt(configObj.coverage), parseInt(configObj.numofblanks), parseInt(configObj.oiltemp), parseInt(configObj.asShipped))
            .then((result) => {
                if (result.success) {
                    toast.success("Configuration saved successfully.");
                    return JSON.parse(result.payload).data[0][0];
                }
                else {
                    toast.error("Configuration save failed.");
                }
            })
            .then((newConfigID) => {
                if (newConfigID !== undefined) {
                    upperHeaderObj.configid = newConfigID;
                    lowerHeaderObj.configid = newConfigID;

                    //save upper header
                    HeaderSave(
                        upperHeaderObj.headerid, parseInt(upperHeaderObj.configid), upperHeaderObj.location, parseInt(upperHeaderObj.flowsp),
                        parseInt(upperHeaderObj.outerbarsprayvoltage), parseInt(upperHeaderObj.outerbarrestingvoltage), parseInt(upperHeaderObj.outerbaridlevoltage),
                        parseInt(upperHeaderObj.centerbarsprayvoltage), parseInt(upperHeaderObj.centerbarrestingvoltage), parseInt(upperHeaderObj.centerbaridlevoltage),
                        parseInt(upperHeaderObj.nozzlesprayvoltage), parseInt(upperHeaderObj.nozzlerestingvoltage), parseInt(upperHeaderObj.nozzleidlevoltage),
                        "", "", "",
                        parseInt(upperHeaderObj.highvoltageontime), parseInt(upperHeaderObj.highvoltageofftime),
                        parseInt(upperHeaderObj.nozzletimeon), parseInt(upperHeaderObj.nozzletimeoff)
                    )
                        .then((result) => {
                            if (!result.success) {
                                toast.error("Upper header save failed.");
                            }

                        });

                    //save lower header
                    HeaderSave(
                        lowerHeaderObj.headerid, parseInt(lowerHeaderObj.configid), lowerHeaderObj.location, parseInt(lowerHeaderObj.flowsp),
                        "", "", "",
                        "", "", "",
                        parseInt(lowerHeaderObj.nozzlesprayvoltage), parseInt(lowerHeaderObj.nozzlerestingvoltage), parseInt(lowerHeaderObj.nozzleidlevoltage),
                        parseInt(lowerHeaderObj.boostsprayvoltage), parseInt(lowerHeaderObj.boostrestingvoltage), parseInt(lowerHeaderObj.boostidlevoltage),
                        parseInt(lowerHeaderObj.highvoltageontime), parseInt(lowerHeaderObj.highvoltageofftime),
                        parseInt(lowerHeaderObj.nozzletimeon), parseInt(lowerHeaderObj.nozzletimeoff)
                    )
                        .then((result) => {
                            if (!result.success) {
                                toast.error("Upper header save failed.");
                            }

                        });
                }
            });
    };

    document.title = "New Configuration";
    return (
        <>
            {user.email &&
                <div className="container body-content" style={{ marginTop: "25px" }}>

                    <div style={{ display: "flex", flexDirection: "row", width: "1140px", marginBottom: "8px", justifyContent: "space-between" }}>
                        <Link to={`/Oilers/Details/${oiler["OilerID"]}`} className="btn btn-default" style={{ marginRight: "4px", width: "auto" }}>Back</Link>
                        <button className="btn btn-success" onClick={handleSave} style={{ margin: "0px", width: "128px" }}>Submit</button>
                    </div>

                    <h2>New Configuration for Oiler <u>{oiler.JobNum} - {oiler.CustomerID}</u></h2>

                    <div className="card mb-4" style={{ width: "100%" }}>
                        <div className="card-header" style={{ fontSize: "20px", backgroundColor: "var(--bs-secondary)", color: "var(--bs-light)" }}>
                            Import Configuration
                        </div>
                        <div className="card-body" style={{ display: "flex", flexDirection: "column" }}>

                            <div className="alert alert-light" style={{ width: "auto" }}> Import recipe from existing configuration?</div>
                            <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>

                                <div style={{ width: "74%", margin: "1%" }}>
                                    <select className="form-select" id="select_importconfig" style={{ fontSize: "16px", minWidth: "100%" }}>
                                        <option value="">Select Configuration</option>
                                        {configurations.map((config, index) => {
                                            return (
                                                <option key={index} value={config.ConfigID}>{config.configString}</option>
                                            );
                                        }
                                        )}
                                    </select>
                                </div>

                                <div style={{ width: "24%", margin: "1%" }}>
                                    <button onClick={handleImportConfiguration} className="btn btn-info" style={{ margin: "1%", width: "48%" }}>Import</button>
                                </div>

                            </div>

                        </div>
                    </div>

                    <div style={{ width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between", alignContent: "center" }}>
                        <div className="alert alert-warning" style={{ width: "auto", height: "48px" }}><b>Warning!</b> To ensure test set integrity, these values cannot be modified outside of this page. Please ensure all values are correct before submitting.</div>
                        <div style={{ margin: "0px", height: "48px" }}><button onClick={handleClearAllFields} className="btn btn-danger" style={{ height: "48px" }}>Clear All Fields</button></div>
                    </div>

                    {/* Oiler Data */}
                    <div className="card mb-4" style={{ marginTop: "8px" }}>
                        <div className="card-header" style={{ fontSize: "20px", backgroundColor: "#158cba", color: "var(--bs-light)" }}>
                            Oiler Data
                        </div>
                        <div className="card-body">
                            <div className="d-flex flex-row">
                                <table className="table table-bordered mx-2" style={{ width: "50%" }}>
                                    <tbody>
                                        <tr>
                                            <th scope="row" style={{ backgroundColor: "var(--bs-gray-300)" }}>Oiler ID</th>
                                            <td style={{ textAlign: "center", verticalAlign: "middle", backgroundColor: "var(--bs-gray-300)" }}>{oiler.OilerID}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row" style={{ backgroundColor: "var(--bs-gray-300)" }}>Job Number</th>
                                            <td style={{ textAlign: "center", verticalAlign: "middle", backgroundColor: "var(--bs-gray-300)" }}>{oiler.JobNum}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row" style={{ backgroundColor: "var(--bs-gray-300)" }}>JB Customer ID</th>
                                            <td style={{ textAlign: "center", verticalAlign: "middle", backgroundColor: "var(--bs-gray-300)" }}>{oiler.CustomerID}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row" style={{ backgroundColor: "var(--bs-gray-300)" }}>Customer Name</th>
                                            <td style={{ textAlign: "center", verticalAlign: "middle", backgroundColor: "var(--bs-gray-300)" }}>{oiler.CustomerName}</td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table className="table table-bordered mx-2" style={{ width: "50%" }}>
                                    <tbody>
                                        <tr>
                                            <th scope="row" style={{ backgroundColor: "var(--bs-gray-300)" }}>Date Created</th>
                                            <td style={{ textAlign: "center", verticalAlign: "middle", backgroundColor: "var(--bs-gray-300)" }}>{oiler.DateCreated}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row" style={{ backgroundColor: "var(--bs-gray-300)" }}>Created By</th>
                                            <td style={{ textAlign: "center", verticalAlign: "middle", backgroundColor: "var(--bs-gray-300)" }}>{oiler.CreatedByName}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row" style={{ backgroundColor: "var(--bs-gray-300)" }}># Test Points</th>
                                            <td style={{ textAlign: "center", verticalAlign: "middle", backgroundColor: "var(--bs-gray-300)" }}>{oiler.NumTestPoints}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row" style={{ backgroundColor: "var(--bs-gray-300)" }}>Infeed Sensor Distance <span style={{ color: "var(--bs-secondary)" }}>(in)</span></th>
                                            <td style={{ textAlign: "center", verticalAlign: "middle", backgroundColor: "var(--bs-gray-300)" }}>{oiler.InFeedSensorDistance}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    {/* Configuration Data */}
                    <div className="card mb-4">
                        <div className="card-header" style={{ fontSize: "20px", backgroundColor: "#158cba", color: "var(--bs-light)" }}>
                            Configuration Data
                        </div>
                        <div className="card-body">
                            <div className="d-flex flex-row">
                                <table className="table table-bordered mx-2" style={{ width: "50%" }}>
                                    <tbody>

                                        <tr>
                                            <th scope="row">Customer Blank #</th>
                                            <td style={{ textAlign: "center", verticalAlign: "middle" }}><input autoComplete="off" id="input_customerblanknum" type="text" className="form-control" /></td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Coverage Target<span style={{ color: "var(--bs-secondary)" }}>(mg/sqft)</span></th>
                                            <td style={{ textAlign: "center", verticalAlign: "middle" }}><input autoComplete="off" id="input_coverage" type="text" className="form-control" /></td>
                                        </tr>
                                        <tr>
                                            <th scope="row"># Blanks</th>
                                            <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                                                <select id="input_numblanks" className="form-select" style={{ fontSize: "16px" }}>
                                                    <option value="">Select Option</option>
                                                    <option value="1">Single</option>
                                                    <option value="2">Double</option>
                                                </select>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table className="table table-bordered mx-2" style={{ width: "50%" }}>
                                    <tbody>
                                        <tr>
                                            <th scope="row">Length <span className="text-secondary">(mm)</span></th>
                                            <td style={{ textAlign: "center", verticalAlign: "middle" }}><input autoComplete="off" id="input_length" type="text" className="form-control" /></td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Width <span className="text-secondary">(mm)</span></th>
                                            <td style={{ textAlign: "center", verticalAlign: "middle" }}><input autoComplete="off" id="input_width" type="text" className="form-control" /></td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Speed <span style={{ color: "var(--bs-secondary)" }}>(fpm)</span></th>
                                            <td style={{ textAlign: "center", verticalAlign: "middle" }}><input autoComplete="off" id="input_speed" type="text" className="form-control" /></td>
                                        </tr>

                                        <tr>
                                            <th scope="row">As Shipped?</th>
                                            <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                                                <select id="input_asshipped" className="form-select" style={{ fontSize: "16px" }}>
                                                    <option value="">Select Option</option>
                                                    <option value="True">Yes</option>
                                                    <option value="False">No</option>
                                                </select>
                                            </td>
                                        </tr>

                                    </tbody>
                                </table>

                            </div>

                        </div>
                    </div>

                    {/* Oil selection */}
                    <div className="card mb-4">
                        <div className="card-header" style={{ fontSize: "20px", backgroundColor: "#158cba", color: "var(--bs-light)" }}>
                            Oil Selection
                        </div>
                        <div className="card-body">
                            <div className="d-flex flex-row">
                                <table className="table table-bordered mx-2" style={{ width: "50%" }}>
                                    <tbody>
                                        <tr>
                                            <th scope="row">Oil Name</th>
                                            <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                                                <select id="input_oilname" className="form-select" style={{ fontSize: "16px" }}>
                                                    <option value="">Select Oil</option>
                                                    {oils.map((oil, index) => {
                                                        return (
                                                            <option key={index} value={oil.OilID}>{oil.OilName}</option>
                                                        );
                                                    }
                                                    )}
                                                </select>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table className="table table-bordered mx-2" style={{ width: "50%" }}>
                                    <tbody>
                                        <tr>
                                            <th scope="row">Oil Temp <span style={{ color: "var(--bs-secondary)" }}>(°C)</span></th>
                                            <td style={{ textAlign: "center", verticalAlign: "middle" }}><input autoComplete="off" id="input_oiltemp" type="text" className="form-control" /></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    {/* Header Data */}
                    <div className="card mb-4">
                        <div className="card-header" style={{ fontSize: "20px", backgroundColor: "#158cba", color: "var(--bs-light)" }}>
                            Upper Header
                        </div>
                        <div className="card-body">

                            <table className="table table-bordered table-striped">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>Outer Bar</th>
                                        <th>Center Bar</th>
                                        <th>Nozzle</th>
                                        {/* <th>Boost</th> */}
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <th scope="row">Spray Voltage <span style={{ color: "var(--bs-secondary)" }}>(kV)</span></th>
                                        <td style={{ textAlign: "center", verticalAlign: "middle" }}><input autoComplete="off" id="input_upperouterspray" type="text" className="form-control" /></td>
                                        <td style={{ textAlign: "center", verticalAlign: "middle" }}><input autoComplete="off" id="input_uppercenterspray" type="text" className="form-control" /></td>
                                        <td style={{ textAlign: "center", verticalAlign: "middle" }}><input autoComplete="off" id="input_uppernozzlespray" type="text" className="form-control" /></td>
                                        {/* <td style={{ textAlign: "center", verticalAlign: "middle" }}><input autoComplete="off" id="input_upperboostspray" type="text" className="form-control" disabled /></td> */}
                                    </tr>
                                    <tr>
                                        <th scope="row">Resting Voltage <span style={{ color: "var(--bs-secondary)" }}>(kV)</span></th>
                                        <td style={{ textAlign: "center", verticalAlign: "middle" }}><input autoComplete="off" id="input_upperouterrest" type="text" className="form-control" /></td>
                                        <td style={{ textAlign: "center", verticalAlign: "middle" }}><input autoComplete="off" id="input_uppercenterrest" type="text" className="form-control" /></td>
                                        <td style={{ textAlign: "center", verticalAlign: "middle" }}><input autoComplete="off" id="input_uppernozzlerest" type="text" className="form-control" /></td>
                                        {/* <td style={{ textAlign: "center", verticalAlign: "middle" }}><input autoComplete="off" id="input_upperboostrest" type="text" className="form-control" disabled /></td> */}
                                    </tr>
                                    <tr>
                                        <th scope="row">Idle Voltage <span style={{ color: "var(--bs-secondary)" }}>(kV)</span></th>
                                        <td style={{ textAlign: "center", verticalAlign: "middle" }}><input autoComplete="off" id="input_upperouteridle" type="text" className="form-control" /></td>
                                        <td style={{ textAlign: "center", verticalAlign: "middle" }}><input autoComplete="off" id="input_uppercenteridle" type="text" className="form-control" /></td>
                                        <td style={{ textAlign: "center", verticalAlign: "middle" }}><input autoComplete="off" id="input_uppernozzleidle" type="text" className="form-control" /></td>
                                        {/* <td style={{ textAlign: "center", verticalAlign: "middle" }}><input autoComplete="off" id="input_upperboostidle" type="text" className="form-control" disabled /></td> */}
                                    </tr>
                                </tbody>
                            </table>

                            <table className="table table-bordered table-striped">
                                <thead>
                                    <tr>
                                        <th style={{ width: "25%" }}></th>
                                        <th style={{ width: "25%" }}>High Voltage</th>
                                        <th style={{ width: "25%" }}>Nozzle Times</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <th scope="row">On Time <span style={{ color: "var(--bs-secondary)" }}>(ms)</span></th>
                                        <td style={{ textAlign: "center", verticalAlign: "middle" }}><input autoComplete="off" id="input_upperhighvoltageon" type="text" className="form-control" /></td>
                                        <td style={{ textAlign: "center", verticalAlign: "middle" }}><input autoComplete="off" id="input_uppernozzletimeon" type="text" className="form-control" /></td>
                                    </tr>
                                    <tr>
                                        <th scope="row">Off Time <span style={{ color: "var(--bs-secondary)" }}>(ms)</span></th>
                                        <td style={{ textAlign: "center", verticalAlign: "middle" }}><input autoComplete="off" id="input_upperhighvoltageoff" type="text" className="form-control" /></td>
                                        <td style={{ textAlign: "center", verticalAlign: "middle" }}><input autoComplete="off" id="input_uppernozzletimeoff" type="text" className="form-control" /></td>
                                    </tr>
                                </tbody>
                            </table>

                            {/* Flow SP  */}
                            <table className="table table-bordered" style={{ width: "40%" }}>
                                <tbody>
                                    <tr>
                                        <th scope="row">Flow SP <span style={{ color: "var(--bs-secondary)" }}>(cc/min)</span></th>
                                        <td style={{ textAlign: "center", verticalAlign: "middle" }}><input autoComplete="off" id="input_upperflowsp" type="text" className="form-control" /></td>
                                    </tr>

                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="card mb-4">
                        <div className="card-header" style={{ fontSize: "20px", backgroundColor: "#158cba", color: "var(--bs-light)" }}>
                            Lower Header
                        </div>
                        <div className="card-body">

                            <table className="table table-bordered table-striped">
                                <thead>
                                    <tr>
                                        <th></th>
                                        {/* <th>Outer Bar</th> */}
                                        {/* <th>Center Bar</th> */}
                                        <th>Nozzle</th>
                                        <th>Boost</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <th scope="row">Spray Voltage <span style={{ color: "var(--bs-secondary)" }}>(kV)</span></th>
                                        {/* <td style={{ textAlign: "center", verticalAlign: "middle" }}><input autoComplete="off" id="input_lowerouterspray" type="text" className="form-control" disabled /></td> */}
                                        {/* <td style={{ textAlign: "center", verticalAlign: "middle" }}><input autoComplete="off" id="input_lowercenterspray" type="text" className="form-control" disabled /></td> */}
                                        <td style={{ textAlign: "center", verticalAlign: "middle" }}><input autoComplete="off" id="input_lowernozzlespray" type="text" className="form-control" /></td>
                                        <td style={{ textAlign: "center", verticalAlign: "middle" }}><input autoComplete="off" id="input_lowerboostspray" type="text" className="form-control" /></td>
                                    </tr>
                                    <tr>
                                        <th scope="row">Resting Voltage <span style={{ color: "var(--bs-secondary)" }}>(kV)</span></th>
                                        {/* <td style={{ textAlign: "center", verticalAlign: "middle" }}><input autoComplete="off" id="input_lowerouterrest" type="text" className="form-control" disabled /></td> */}
                                        {/* <td style={{ textAlign: "center", verticalAlign: "middle" }}><input autoComplete="off" id="input_lowercenterrest" type="text" className="form-control" disabled /></td> */}
                                        <td style={{ textAlign: "center", verticalAlign: "middle" }}><input autoComplete="off" id="input_lowernozzlerest" type="text" className="form-control" /></td>
                                        <td style={{ textAlign: "center", verticalAlign: "middle" }}><input autoComplete="off" id="input_lowerboostrest" type="text" className="form-control" /></td>
                                    </tr>
                                    <tr>
                                        <th scope="row">Idle Voltage <span style={{ color: "var(--bs-secondary)" }}>(kV)</span></th>
                                        {/* <td style={{ textAlign: "center", verticalAlign: "middle" }}><input autoComplete="off" id="input_lowerouteridle" type="text" className="form-control" disabled /></td> */}
                                        {/* <td style={{ textAlign: "center", verticalAlign: "middle" }}><input autoComplete="off" id="input_lowercenteridle" type="text" className="form-control" disabled /></td> */}
                                        <td style={{ textAlign: "center", verticalAlign: "middle" }}><input autoComplete="off" id="input_lowernozzleidle" type="text" className="form-control" /></td>
                                        <td style={{ textAlign: "center", verticalAlign: "middle" }}><input autoComplete="off" id="input_lowerboostidle" type="text" className="form-control" /></td>
                                    </tr>
                                </tbody>
                            </table>

                            <table className="table table-bordered table-striped">
                                <thead>
                                    <tr>
                                        <th style={{ width: "25%" }}></th>
                                        <th style={{ width: "25%" }}>High Voltage</th>
                                        <th style={{ width: "25%" }}>Nozzle Times</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <th scope="row">On Time <span style={{ color: "var(--bs-secondary)" }}>(ms)</span></th>
                                        <td style={{ textAlign: "center", verticalAlign: "middle" }}><input autoComplete="off" id="input_lowerhighvoltageon" type="text" className="form-control" /></td>
                                        <td style={{ textAlign: "center", verticalAlign: "middle" }}><input autoComplete="off" id="input_lowernozzletimeon" type="text" className="form-control" /></td>
                                    </tr>
                                    <tr>
                                        <th scope="row">Off Time <span style={{ color: "var(--bs-secondary)" }}>(ms)</span></th>
                                        <td style={{ textAlign: "center", verticalAlign: "middle" }}><input autoComplete="off" id="input_lowerhighvoltageoff" type="text" className="form-control" /></td>
                                        <td style={{ textAlign: "center", verticalAlign: "middle" }}><input autoComplete="off" id="input_lowernozzletimeoff" type="text" className="form-control" /></td>
                                    </tr>
                                </tbody>
                            </table>

                            {/* Flow SP  */}
                            <table className="table table-bordered" style={{ width: "50%" }}>
                                <tbody>
                                    <tr>
                                        <th scope="row">Flow SP <span style={{ color: "var(--bs-secondary)" }}>(cc/min)</span></th>
                                        <td style={{ textAlign: "center", verticalAlign: "middle" }}><input autoComplete="off" id="input_lowerflowsp" type="text" className="form-control" /></td>
                                    </tr>

                                </tbody>
                            </table>

                        </div>
                    </div>

                    <div style={{ display: "flex", flexDirection: "row", width: "1140px", marginBottom: "8px", justifyContent: "space-between" }}>
                        <Link to={`/Oilers/Details/${oiler["OilerID"]}`} className="btn btn-default" style={{ marginRight: "4px", width: "auto" }}>Back</Link>
                        <button className="btn btn-success" onClick={handleSave} style={{ margin: "0px", width: "128px" }}>Submit</button>
                    </div>

                </div >
            }

        </>
    );
};

export default OilerConfigurationNew;
